import { gql } from 'graphql.macro';

export const addOrderTagTemplate = gql`
    mutation addOrderTag($name: String!, $color: String!) {
        addOrderTag(name: $name, color: $color) {
            _id
            name
            color
        }
    }
`;

export const modifyOrderTagTemplate = gql`
    mutation modifyOrderTag($tagId: MongoDbObjectId, $name: String, $color: String) {
        modifyOrderTag(tagId: $tagId, name: $name, color: $color) {
            _id
            name
            color
        }
    }
`;

export const deleteOrderTagTemplate = gql`
    mutation deleteOrderTag($tagId: MongoDbObjectId!) {
        deleteOrderTag(tagId: $tagId)
    }
`;

export const reorderOrderTagsTemplate = gql`
    mutation reorderOrderTags($tagIds: [MongoDbObjectId!]!) {
        reorderOrderTags(tagIds: $tagIds) {
            _id
            name
            color
        }
    }
`;

export const assignOrderTagTemplate = gql`
    mutation assignOrderTag($orderId: MongoDbObjectId!, $tagIds: [MongoDbObjectId!]!) {
        assignOrderTag(orderId: $orderId, tagIds: $tagIds) {
            _id
            orderTags {
                _id
                name
                color
            }
        }
    }
`;
